import { createFileRoute } from '@tanstack/react-router';

import ProductSettingsPage from '@/components/products/specific/settings/Page';

export const Route = createFileRoute('/products/$id/settings')({
	component: ProductSettingsPage,
});
